import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  dataRow: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(4),
  },
}));

export default useStyles;
